export class BaseEntity {
  id?: number;
  lastUpdatedDate?: Date;
  lastUpdatedUserId?: number;
  createdDate?: Date;
  deleted?: number;
  createdUserId?: number;
}
